import { useStore } from '../store/useStore';
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Legend,
  Tooltip,
} from 'recharts';
import { calculateDimensionAverages } from '../lib/ruleEngine';

export function RadarChartComponent() {
  const { studentDataList } = useStore();

  const dimensionData = calculateDimensionAverages(studentDataList);

  const chartData = dimensionData.map((item) => ({
    dimension: item.dimension,
    average: item.avgScore,
    fullMark: 4,
  }));

  if (studentDataList.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-lg p-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">班级雷达图</h3>
        <div className="h-64 flex items-center justify-center text-gray-400">
          暂无数据，请先上传Excel文件
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">班级维度分析</h3>
      <ResponsiveContainer width="100%" height={300}>
        <RadarChart data={chartData}>
          <PolarGrid stroke="#e0e0e0" />
          <PolarAngleAxis
            dataKey="dimension"
            tick={{ fill: '#666', fontSize: 12 }}
          />
          <PolarRadiusAxis
            angle={30}
            domain={[0, 4]}
            tick={{ fill: '#999', fontSize: 10 }}
          />
          <Radar
            name="班级均值"
            dataKey="average"
            stroke="#1a73e8"
            fill="#1a73e8"
            fillOpacity={0.5}
          />
          <Tooltip
            formatter={(value: number) => [value.toFixed(2), '均值']}
            labelStyle={{ color: '#333' }}
          />
          <Legend />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}